import { render, staticRenderFns } from "./MRListOnHold.vue?vue&type=template&id=7fc643a2"
import script from "./MRListOnHold.vue?vue&type=script&lang=ts"
export * from "./MRListOnHold.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports